import React, { useEffect, useState } from "react";
import { ToastContainer } from "react-toastify";
import { CONSTITUENCY_CONFIG_URL } from "../../../../api/api_routing_urls";
import useAuth from "../../../../authentication/hooks/useAuth";
import useAxiosPrivate from "../../../../authentication/hooks/useAxiosPrivate";
import Dashboard from "../../../../common/Dashboard";
import MasterConfigHeaderWithoutDeleteWrapper from "../../../../common/master-config/MasterConfigHeaderWithoutDeleteWrapper";
import GenericModal from "../../../../reusable-components/modals/GenericModal";
import showToast from "../../../../utilities/notification/NotificationModal";
import AddConstituencyForm from "./AddConstituencyForm";
import ConstituencyList from "./ConstituencyList";

const ConstituencyConfig = () => {
  const { auth } = useAuth();
  const [constituencyList, setConstituencyList] = useState([]);
  const axiosPrivate = useAxiosPrivate();
  const [showAddForm, setShowAddForm] = useState(false);
  const [editConstituencyDetails, setEditConstituencyDetails] = useState({});
  const isEdit = Object.keys(editConstituencyDetails).length > 0 ? true : false;
  const controller = new AbortController();

  const getConstituencyList = async () => {
    try {
      const response = await axiosPrivate.get(CONSTITUENCY_CONFIG_URL, {
        signal: controller.signal,
      });
      response.status === 200 &&
        setConstituencyList(response.data.constituencyList);
      response.status === 202 &&
        showToast("No state list found in the system", "error");
    } catch (error) {
      console.error(error);
      if (!error?.response) {
        showToast("No Server Response");
      } else if (error.response.status === 422) {
        showToast("Some of the required inputs were not provided", "error");
      } else {
        showToast(
          "Whoops!!!! This doesn't feel right. There might be an issue. Please contact administrator",
          "error"
        );
      }
    }
  };

  useEffect(() => {
    let isMounted = true;
    getConstituencyList();
    setEditConstituencyDetails({});
    return () => {
      isMounted = false;
      controller.abort();
    };
  }, []);
  return (
    <Dashboard sidebarType={auth.rolename}>
      <ToastContainer />
      <MasterConfigHeaderWithoutDeleteWrapper
        headerTitle={"Constituency"}
        setShowAddForm={setShowAddForm}
      />
      <GenericModal
        open={showAddForm}
        setOpen={setShowAddForm}
        title={` ${isEdit ? "Update Constituency" : "Add Constituency"}`}
        isAdd={true}
      >
        <AddConstituencyForm
          getConstituencyList={getConstituencyList}
          editConstituencyDetails={editConstituencyDetails}
          setEditConstituencyDetails={setEditConstituencyDetails}
          setShowAddForm={setShowAddForm}
        />
      </GenericModal>
      <div className="grid grid-cols-1">
        <ConstituencyList
          constituencyList={constituencyList}
          setEditConstituencyDetails={setEditConstituencyDetails}
          setShowAddForm={setShowAddForm}
        />
      </div>
    </Dashboard>
  );
};

export default ConstituencyConfig;
